<template>
	<!--筛选条件-->
	<div :class="isfenlie == 'true' ? 'filterBox-a' : 'filterBox'">
		<template v-for="item in list">
			<template v-for="(value, key) in item.arr" :key="key">
				<div class="filter-item">
					<div class="item-tit">{{ key }}：</div>
					<div :class="child == 'achievements' ? 'item-a' : 'item-info'">
						<dl>
							<dt>
								<label>
									<a :class="sign[item.search] == '-1' ? 'on' : ''">
										<input type="radio" :name='key' :value="-1" v-model="sign[item.search]"
											@click="handleSign(item.search, '')">
										不限
									</a>
								</label>
							</dt>
						</dl>
					</div>
					<template v-for="(i, j) in value" :key="j">
						<div :class="child == 'achievements' ? 'item-a' : 'item-info'">
							<dl>
								<dt>
									<label>
										<a :class="sign[item.search] == j ? 'on' : ''">
											<input type="radio" :name='key' :value="j" v-model="sign[item.search]"
												@click="handleSign(item.search, i.dictValue)" />
											{{ i.dictLabel }}
										</a>
									</label>
								</dt>
							</dl>
						</div>
					</template>
					<div class="clear"></div>
				</div>
			</template>
		</template>
	</div>
</template>

<script>
export default {
	name: "",
	props: {
		list: {
			type: Array,
			default() {
				return []
			}
		},
		child: {
			type: String,
			default: ""
		},
		isfenlie: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			search: {},
			sign: {
				professionalTitle: -1,
				researchArea: -1,
				grade: -1,
				type: -1,
				companyProperty: -1,
				businessscope: -1,
				thinkTankType: -1,
				releaseType: -1,
				// 科技成果   成果类型
				achievementClassify: -1,
				// 科技成果   技术领域
				technoSphere: -1,
				// 科技成果   技术成熟度
				techMaturity: -1,
				researchField: -1,
				projectDemand: -1,
				// 科技成果  技术需求 技术领域
				highTechField: -1,
				trType: -1,
			},
		}
	},
	mounted() {
		this.$emit('changeValue', this.search)
	},
	computed: {

	},
	methods: {
		handleSign(type, index) {
			this.search[type] = index
			this.$emit('changeValue', this.search)
		}
	}
}
</script>

<style scoped lang="less">
.item-info input {
	position: absolute;
	left: -99999px;
}

.item-a input {
	position: absolute;
	left: -99999px;
}

/*筛选条件框*/
.filterBox {
	overflow: hidden;
	border: 1px solid #dedede;
	padding: 15px 0;
	width: 1200px;
	margin: 0 auto 20px auto;

	.filter-item {
		line-height: 26px;
		padding: 0 20px;
		overflow: hidden;

		.item-tit {
			float: left;
			width: 80px;
		}

		.item-info {
			position: relative;
			padding-left: 80px;

			dl {
				float: left;
				margin-bottom: 10px;
			}

			a {
				float: none;
				display: inline-block;
				margin: 0 10px 0 0;
				padding: 0 10px;
				border-radius: 3px;
				color: #333;

				&:hover {
					background: #035aea;
					color: #fff;
				}
			}

			.on {
				background: #035aea;
				color: #fff;
			}
		}

		.item-a {
			position: relative;
			padding-left: 80px;

			dl {
				float: left;
				margin-bottom: 10px;
			}

			a {
				float: none;
				display: inline-block;
				margin: 0 10px 0 0;
				padding: 0 10px;
				border-radius: 3px;
				color: #333;

				&:hover {
					background: #fc550b;
					color: #fff;
				}
			}

			.on {
				background: #fc550b;
				color: #fff;
			}
		}
	}
}
.filterBox-a {
	overflow: hidden;
	border: 1px solid #dedede;
	padding: 15px 0;
	margin: 0 auto 20px auto;

	.filter-item {
		line-height: 26px;
		padding: 0 20px;
		overflow: hidden;

		.item-tit {
			float: left;
			width: 80px;
		}

		.item-info {
			position: relative;
			padding-left: 80px;

			dl {
				float: left;
				margin-bottom: 10px;
			}

			a {
				float: none;
				display: inline-block;
				margin: 0 10px 0 0;
				padding: 0 10px;
				border-radius: 3px;
				color: #333;

				&:hover {
					background: #035aea;
					color: #fff;
				}
			}

			.on {
				background: #035aea;
				color: #fff;
			}
		}

		.item-a {
			position: relative;
			padding-left: 80px;

			dl {
				float: left;
				margin-bottom: 10px;
			}

			a {
				float: none;
				display: inline-block;
				margin: 0 10px 0 0;
				padding: 0 10px;
				border-radius: 3px;
				color: #333;

				&:hover {
					background: #fc550b;
					color: #fff;
				}
			}

			.on {
				background: #fc550b;
				color: #fff;
			}
		}
	}
}
</style>
